window.loadedSentryIntegrations = window.loadedSentryIntegrations || [];

function filterAlreadyLoadedIntegrations(wantedIntegrations) {
  const result = [];
  for (const integration of wantedIntegrations) {
	if (!window.loadedSentryIntegrations.includes(integration)) {
	  window.loadedSentryIntegrations.push(integration);
	  result.push(integration);
	}
  }
  return result;
}


export default function getSentryConfig(Sentry) {
  const wantedIntegrations = [
	Sentry.browserTracingIntegration(),
	Sentry.replayIntegration(),
  ];

  const thirdPartyErrorFilterIntegration = Sentry.thirdPartyErrorFilterIntegration?.({
	filterKeys: ["roh-js-app"],
	behaviour: "drop-error-if-contains-third-party-frames",
  });
  if (thirdPartyErrorFilterIntegration) {
	wantedIntegrations.push(thirdPartyErrorFilterIntegration);
  }

  return {
	dsn: window.SENTRY_DSN,
	integrations: filterAlreadyLoadedIntegrations(wantedIntegrations),
	environment: window.ENVIRONMENT,
	ignoreErrors: ["Invalid site key or not loaded", "recaptcha"],
	tracesSampleRate: window.SENTRY_TRACE_SAMPLE_RATE || 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: window.SENTRY_SAMPLE_RATE
  };
}
